import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle, FiSlash, FiStar } = FiIcons;

export function BotAvatar({ bot, small = false }) {
  return <span className={`bot-avatar ${small ? 'small' : ''}`} style={{ background: bot.color }}>{bot.name?.[0] || '?'}</span>;
}

export function BotCard({ bot, team, selected, onClick }) {
  return (
    <button className={`bot-card ${selected ? 'selected' : ''}`} onClick={onClick}>
      <BotAvatar bot={bot} />
      <span className="bot-copy"><b>{bot.name}</b><small>{bot.role}</small><em>{team?.name}</em></span>
      <span className={`status-dot ${bot.enabled ? 'on' : ''}`} title={bot.enabled ? 'Enabled' : 'Disabled'}>
        <SafeIcon icon={bot.enabled ? FiCheckCircle : FiSlash} />
      </span>
      {bot.isLead && <span className="lead-badge"><SafeIcon icon={FiStar} /> Lead</span>}
    </button>
  );
}

export function TeamRoster({ team, bots }) {
  const ordered = [...bots].sort((a, b) => Number(b.isLead) - Number(a.isLead));
  return (
    <section className="panel roster-panel">
      <div className="section-heading"><div><span className="eyebrow">Team roster</span><h3>{team?.name}</h3></div><span className="count">{bots.length}</span></div>
      <div className="roster-list">
        {ordered.map((bot) => <BotCard key={bot.id} bot={bot} team={team} />)}
      </div>
    </section>
  );
}